import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance, computed, watch } from 'vue'
import { getBrandListApi } from '@/apis/brand'
import { BrandM } from '@/models/brand'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectBrand',
  props: {
    classNames: {   // 类名
        type: Array,
        default: ['filter-item']
    },
    filterable: {   // 是否可筛选
        type: Boolean,
        default: true
    },
    clearable: {    // 是否可一键清除
        type: Boolean,
        default: true
    },
    disabled: {     // 是否禁用
        type: Boolean,
        default: false
    },
    multiple: {     // 是否可多选
        type: Boolean,
        default: false
    },
    ifBody: {     // 品牌类型：0-实物（默认），1-电子券，2-全部
        type: Number,
        default: 2
    },
    idShow: {     // id_show=1 会将对应的品牌ID与品牌名称连接进行返回 
        type: Number,
        default: 0
    },
    status: {    // 品牌上下架状态，默认全部
        type: Number,
        default: 2
    },
    placeholder: {    // 提示信息
        type: String,
        default: '请选择品牌'
    },
    limitShow: {
        type: Boolean,
        default: false
    },
    modelValue: {
        type: [String, Number],
        default: ''
    }
},
  emits: ['brandChange', 'update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {

const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props

const brandProps = {
    value: 'id',
    label: 'name'
}
const selectedId = ref<any>(props.modelValue || undefined)
const list = ref<BrandM[]>([])
const onGetList = async () => {
    const {code, data, msg} = await getBrandListApi({
        if_body: props.ifBody,
        id_show: props.idShow,
        status: props.status
    }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    list.value = data
    
    // 如果有初始值，设置为selectedId，确保类型一致
    if (props.modelValue) {
        const brandId = typeof props.modelValue === 'string' ? parseInt(props.modelValue) : props.modelValue
        selectedId.value = brandId
    } else if (list.value.length == 1 && !show.value) {
        selectedId.value = list.value[0].id
        onSelectedChange()
    }
}
onGetList()

const show = computed(() => {
    return props.limitShow == false || props.limitShow == true && list.value.length > 1
})

// 监听外部modelValue变化，同步到内部
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            // 确保selectedId与品牌列表中的id类型一致
            const brandId = typeof newVal === 'string' ? parseInt(newVal) : newVal
            selectedId.value = brandId
        } else {
            selectedId.value = ''
        }
    },
    { immediate: true, deep: true }
)

watch(
    selectedId,
    (newVal) => {
        emits('update:modelValue', newVal)
    },
    { deep: true }
)

// 品牌变化，通过父组件
const onSelectedChange = () => {
    emits('brandChange', selectedId.value)
}
// 清空数据
const clear = () => {
    selectedId.value = ''
}
__expose({
    clear
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_select_v2, {
    class: _normalizeClass(__props.classNames),
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedId).value = $event)),
    filterable: __props.filterable,
    clearable: __props.clearable,
    multiple: __props.multiple,
    placeholder: __props.placeholder,
    props: brandProps,
    options: list.value,
    disabled: __props.disabled,
    onChange: onSelectedChange
  }, null, 8, ["class", "modelValue", "filterable", "clearable", "multiple", "placeholder", "options", "disabled"])), [
    [_vShow, show.value]
  ])
}
}

})